import { parseISO } from 'date-fns'
import { AuthContext } from '../data/stores/auth.store'

type ContextBannerProps = {
  context: AuthContext
}

const formatDate = (value?: string) => {
  if (!value) return undefined

  try {
    const locale = typeof navigator !== 'undefined' ? navigator.language : 'en-US'
    const formatter = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })

    return formatter.format(parseISO(value))
  } catch (error) {
    console.error('Failed to format race date from context:', error)
    return undefined
  }
}

export function ContextBanner({ context }: ContextBannerProps) {
  const raceName = context.race ?? 'this race'
  const raceDate = formatDate(context.race_date)
  const image = context.image?.trim() ? context.image : '/placeholder.png'

  return (
    <div className="w-full px-4 sm:px-0">
      <div className="sm:bg-background/85 bg-card flex w-full flex-row overflow-hidden rounded-xl shadow-lg">
        <div className="flex flex-1 flex-col gap-2 px-4 pb-4 pt-5 sm:px-5 sm:pb-5 sm:pt-6">
          <h2 className="text-lg font-semibold">{`Log in / Sign up to continue registering to ${raceName}`}</h2>
          {raceDate && <p className="text-muted-foreground mt-2 text-base font-semibold">{raceDate}</p>}
        </div>
        <div className="relative w-1/4 sm:w-1/2">
          <img src={image} alt={raceName} className="h-full w-full object-cover" />
        </div>
      </div>
    </div>
  )
}

export default ContextBanner
